'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resFailCallback = exports.resSucCallback = exports.reqFailCallback = exports.reqSucCallback = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _config = require('@/config');

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _requestConfig = require('./request-config');

var _responseConfig = require('./response-config');

var _router = require('@/router');

var _router2 = _interopRequireDefault(_router);

var _axios = require('axios');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isBuild = process.env.NODE_ENV === 'production';
var AxiosQueue = {};
// 限制快速点击
var RepeatedQueue = {};
// 请求成功回调
var reqSucCallback = exports.reqSucCallback = function reqSucCallback(config) {
  var source = _axios.CancelToken.source();
  config.cancelToken = source.token;
  //职责链开始
  config.baseURL += isBuild ? '' : _config.prefixPath;
  AxiosQueue['' + config.baseURL + config.url] = source.cancel;
  if (!setStatus(config, 'pending')) {
    source.cancel();
  }
  return _requestConfig.getDuty.exec(config.method.toLowerCase(), config).then(function () {
    return config;
  });
};
// 请求失败回调
var reqFailCallback = exports.reqFailCallback = function reqFailCallback() {};
//响应成功回调
var resSucCallback = exports.resSucCallback = function resSucCallback(res) {
  // if (res && res.status === 200 && power && res.data.code == '5001') {
  //   // 先判断登录
  //   if (!sessionStorage.getItem('authLogin')) {
  //     store.commit('FLUSHCONTENT', '正在进行登录，点击确定刷新登录状态！')
  //     let routeUrl = router.resolve({
  //       name: 'toonLogin',
  //       query: {
  //         type: 'real'
  //       }
  //     })
  //     window.open(routeUrl.href, '_blank')
  //     return
  //   }
  //   // 实名认证跳转
  //   store.commit('FLUSHCONTENT', '正在进行实名认证，点击确定刷新实名认证状态！')
  //   let routeUrl = router.resolve({
  //     name: 'toonUnified',
  //     query: {
  //       type: 'real'
  //     }
  //   })
  //   window.open(routeUrl.href, '_blank')
  //   return
  // }
  delete AxiosQueue[res.config.url];
  var data = _responseConfig.statusDuty.exec(res.status, res);
  setStatus(res.config, 'reject');
  return data.then(function (res) {
    if ((typeof res === 'undefined' ? 'undefined' : (0, _typeof3.default)(res)) === 'object') return _promise2.default.resolve(res);
  });
};
// 响应失败回调
var resFailCallback = exports.resFailCallback = function resFailCallback(_ref) {
  var response = _ref.response,
      config = _ref.config;

  if (response && response.status === 401 && _config.power) {
    localStorage.clear();
    sessionStorage.clear();
    _store2.default.commit('token', false);
    //清空队列请求
    (0, _keys2.default)(AxiosQueue).forEach(function (key) {
      AxiosQueue[key] && AxiosQueue[key]();
      delete AxiosQueue[config.url];
    });
    if (sessionStorage.getItem('oauthHref') && sessionStorage.getItem('oauthHref') != 'undefined') {
      window.location.href = sessionStorage.getItem('oauthHref');
    } else {
      _router2.default.push({ path: '/' });
      _store2.default.commit('FLUSHCONTENT', 'login');
      // let routeUrl = router.resolve({
      //   name: 'toonLogin',
      //   query: {
      //     type: 'real'
      //   }
      // })
      // window.open(routeUrl.href, '_blank')
    }
  }
  setStatus(config, 'reject');
  if (config) {
    delete AxiosQueue[config.url];
  }
  return _promise2.default.reject(response);
};

var setStatus = function setStatus(config, status) {
  if (config && config.method.toLowerCase() === 'post') {
    var Reg = !isBuild ? /api\/(.*)/g : /\/(.*)/g;
    var url = config.url.indexOf(config.baseURL) != 0 ? config.url : Reg.exec(config.url)[1];
    var requestingId = typeof url === 'string' ? url : (0, _stringify2.default)(url);
    if (status == 'pending') {
      if (RepeatedQueue[requestingId] && RepeatedQueue[requestingId].status == 'pending') {
        return false;
      }
    } else {
      if (RepeatedQueue[requestingId]) {
        RepeatedQueue[requestingId].status = status;
      }
      if (RepeatedQueue['/' + requestingId]) {
        RepeatedQueue['/' + requestingId].status = status;
      }
      return true;
    }
    RepeatedQueue[requestingId] = {
      status: 'pending'
    };
  }
  return true;
};